import { useDebouncedState } from '@mantine/hooks';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, isValid } from 'redux-form';
import Button from '../../elements/Button';
import InputDate from '../../elements/DatePicker/DatePicker';
import GridCell from '../../elements/GridCell';
import Select from '../../fields/SelectBox/Select';
import IcAgent from '../../icons/IcAgent';
import { fetchAgen } from '../../layouts/PageBase/actions';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';

export default function EditAgentForm({ data, onClose, handleSubmitAgent, change }){
  const dispatch = useDispatch();
  const [search, setSearch] = useDebouncedState('', 200);
  const { type, agent, startDate, endDate } = fieldsProps;
  const { values } = useSelector((state) => state?.form?.EditAgentForm);
  const [ typeSelected, setTypeSelected ] = useState('');
  const [startDateSelected, setStartDateSelected] = useState('');
  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmitAgent(values);
  };

  const { dataAgents } = useSelector((state) => state?.pageBase);

  useEffect(() => {
    dispatch(fetchAgen('', true));
  },[]);

  useEffect(() => {
    dispatch(fetchAgen(search, true));
  },[search]);

  const isInvalid = () => {
    if(typeSelected === 'Sementara'){
      return !isValid('EditAgentForm') || !values?.agenId || !values?.startDate  || !values?.endDate || dayjs(values?.startDate).toDate() > dayjs(values?.endDate).toDate();
    }else{
      return !isValid('EditAgentForm') || !values?.agenId ||  !values?.type;
    }
  };

  const minDate = () => {
    if(dayjs(data?.registrationDate) < dayjs(new Date()).add(-7, 'days').toDate()){
      return dayjs().add(-7, 'days').toDate();
    }else{
      return dayjs(data?.registrationDate);
    }
  };

  return(
    <form className={styles.container} onSubmit={onSubmit}>
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <IcAgent /> <span>Data Agen</span>
        </div>
        <div className={styles.contentBody}>
          <GridCell data={data?.agen?.id} label="ID Agen" />
          <GridCell data={data.agen?.name} label="Nama Agen" />
          {data?.agen?.status === 'sementara' &&
          <GridCell data={`${data.agen?.startDate} - ${data.agen?.endDate}`} key={0} label="Tanggal"/>
          }
          {data?.agen?.status === 'permanen' &&
          <GridCell data={`${data.agen?.startDate}`} key={1} label="Tanggal" />
          }
        </div>
      </div>
      <div className={styles.formGroup}>
        <Field
          clearable
          component={Select}
          data={type.data}
          inputProps={type}
          name={type.name}
          onChange={(e) => setTypeSelected(e)}
          required={true}
        />
        <Field
          clearable
          component={Select}
          data={dataAgents}
          inputProps={agent}
          name={agent.name}
          onChange={(e) => e === null && setSearch('')}
          onSearchChange={(e) => setSearch(e.target.value)}
          required={true}
        />
        {typeSelected === 'Sementara' &&
          <div className={styles.dateForm}>
            <Field
              component={InputDate}
              inputProps={startDate}
              maxDate={dayjs(new Date()).add(+7, 'days').toDate()}
              minDate={minDate()}
              name={startDate.name}
              onChange={(e) => {
                setStartDateSelected(dayjs(e).format('YYYY-MM-DD'));
                dispatch(change('endDate', ''));
              }
              }
            />
            <Field
              clearable
              component={InputDate}
              inputProps={endDate}
              minDate={dayjs(new Date(startDateSelected)).toDate()}
              name={endDate.name}
            />
          </div>
        }
        {/* {typeSelected === 'Sementara' &&
          <div className={styles.dateForm}>
            <span>{startDate?.info}</span>
            <span>{endDate?.info}</span>
          </div>
        } */}
        <div className={styles.footer}>
          <Button onClick={onClose} outlined>Batal</Button>
          <Button
            disabled={isInvalid()}
            style={'blue'}
            type={'submit'}>Ganti Agen</Button>
        </div>
      </div>
    </form>
  );
}

EditAgentForm.propTypes = {
  change: PropTypes.func,
  data: PropTypes.object,
  handleSubmitAgent: PropTypes.func,
  onClose: PropTypes.func,
};

